import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../../../hooks";
import { useDispatch, useSelector } from "../../../../redux/hooks";
import { toggleSectionCollapse } from "../../../../redux/slices/generatorSlice";
import { setEditing } from "../../../../redux/slices/entrySlice";

interface Props {
  title?: string;
  subtitle?: string;
  sectionIndex?: number;
  collapseable?: boolean;
  collapsed?: boolean;
}

const SectionTitle = ({
  title,
  subtitle,
  sectionIndex,
  collapseable,
  collapsed,
}: Props) => {
  const theme = useTheme() as any;
  const dispatch = useDispatch();
  const location = useLocation();
  const isInLogbookEntry =
    location.pathname.includes("/logbook/") &&
    !location.pathname.includes("/history");
  const type = useSelector(
    state => state.entriesGeneratorSlice.reportDetails?.type,
  );

  // Debug logging for collapse state

  const handleToggleCollapse = () => {
    if (collapseable && typeof sectionIndex === "number" && isInLogbookEntry) {
      dispatch(toggleSectionCollapse({ sectionIndex }));
      dispatch(setEditing(true));
    }
  };

  // Only show collapse functionality in logbook entry editing
  const showCollapseControl = collapseable && isInLogbookEntry;

  if (!title && !subtitle) return null;

  return (
    <div
      className="section-title"
      style={{
        border: `1px solid ${theme.colors.thBorder}`,
        borderBottom: "none",
        padding: type === 3 ? "6px" : "12px",
        margin: 0,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 5,
        textAlign: "start",
        backgroundColor: theme.colors.thBackgroundColor,
        color: theme.colors.thColor[0],
        fontWeight: "bold",
        cursor: showCollapseControl ? "pointer" : "default",
      }}
      onClick={showCollapseControl ? handleToggleCollapse : undefined}>
      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
        {title && <span>{title}</span>}
        {subtitle && (
          <span style={{ fontSize: "12px", fontStyle: "italic" }}>
            {subtitle}
          </span>
        )}
      </div>
      {showCollapseControl && (
        <div
          style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}>
          {collapsed ? (
            <IconChevronDown size={20} />
          ) : (
            <IconChevronUp size={20} />
          )}
        </div>
      )}
    </div>
  );
};
export default SectionTitle;
